export default __webpack_public_path__ + "static/media/Hirakud-24jul17-C2S.725f8df0.webp";